// extracted by mini-css-extract-plugin
module.exports = {"formitem":"AntdFormItem_formitem__2fXyq"};